import {MaxAgeQualifier} from './types'

export const RESULT_COUNTS = [3, 6, 9, 12]
export const ONE_MIN = 60 * 1000

export const MAX_AGE_MENU_ITEMS = [
  {label: '1 month', value: MaxAgeQualifier.OneMonth},
  {label: '3 months', value: MaxAgeQualifier.ThreeMonths},
  {label: '1 year', value: MaxAgeQualifier.OneYear},
  {label: 'No maximum', value: MaxAgeQualifier.NoMax},
]
